import React, { useState } from 'react'
import { FollowimgData } from '../../../../Data/FollowingData'
import "../Following/FollowingU.css"
import FollowingUList from './FollowingUList'
import FollowingMore from './FollowingMore'
import google_play_store_logo from '../../../../assets/images/google-play-store-badge.svg'
import google_play_store_qr_code from "../../../../assets/images/play-store-qr-code.svg"
import apple_play_store_logo from '../../../../assets/images/apple-play-store-badge.svg'
import apple_play_store_qr_code from '../../../../assets/images/apple-store-qr-code.svg'




const FollowingU = ({following,setFollowing}) => {

  const [showMore,setShowMore] =useState(false)
  

  return (
    <div className="following-comp">
      <h2>Scan a QR code and download</h2>
      <div >
        <a href="https://play.google.com/store/apps/details?id=com.memyfolks" target="_blank" >
        <img className="logo-store" src={google_play_store_logo}  /></a>
        <img className="logo-qr" src={google_play_store_qr_code}  />
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div >
        <a href="https://apps.apple.com/in/app/memyfolks/id1620581658" target="_blank"><img className="apple-logo-store" src={apple_play_store_logo}  /></a>
        <img className="logo-qr" src={apple_play_store_qr_code} /> 
 </div>
    </div>
    
  )
}

export default FollowingU